import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const Coverage = {
  type: PropTypes.string,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const CoverageShape = PropTypes.shape(Coverage);
export const CoverageExact = PropTypes.exact(Coverage);
